import io from 'socket.io-client';
import {EventEmitter} from 'events';
import {
    SOCKET_CONNECTED,
    SOCKET_DISCONNECTED,
} from 'reducers/socketConnection/socketConnectionActions';
import {socketApiPrefixPath} from './ApiPaths';

class SocketServer extends EventEmitter {
    addStore(store) {
        this.store = store;
    }

    openConnection() {
        this.socket = new Promise((resolve) => {
            console.log('Connecting to websocket server');

            const socket = io({path: socketApiPrefixPath, transports: ['websocket']});

            socket.on('connect', () => {
                console.log('Connected to websocket server');
                this.dispatchToStore({type: SOCKET_CONNECTED});
                this.emit('ready', socket);
            });

            socket.on('disconnect', () => {
                console.log('Disconnected from websocket server');
                this.dispatchToStore({type: SOCKET_DISCONNECTED});
            });

            resolve(socket);
            this.emit('connect', socket);
        });

        return this;
    }

    closeConnection() {
        if (!this.socket) return;

        this.socket.then((socket) => {
            socket.disconnect();
            socket.removeAllListeners();
            this.emit('disconnect', socket);
        });
    }

    dispatchToStore(action) {
        this.store.dispatch(action);
    }
}

const socketServer = new SocketServer();

export default socketServer;

export function getSocket() {
    return socketServer.socket;
}



// WEBPACK FOOTER //
// ./src/sources/SocketServer.js